import css from './GSTicketSkeleton.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_MEDIUMGREY } from 'utils/constants/colors'

const GSTicketSkeleton: React.FC = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.ticketIcon}>
        <Skeleton
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={200}
          height={'60%'}
          width={'60%'}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          className={css.icon_skeleton}
        />
      </div>

      <div className={css.header}>
        <Skeleton
          className={css.content_skeleton}
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={8}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          height={80}
        />
      </div>

      <div className={css.qr}>
        <Skeleton
          className={css.content_skeleton}
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={8}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
          height={80}
        />
      </div>

      <div className={css.use_drink}>
        <Skeleton
          className={css.content_skeleton}
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={8}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
        />
      </div>

      <div className={css.bottom_label}>
        <Skeleton
          className={css.content_skeleton_bottom}
          baseColor={TICKETSMS_COLORS_MEDIUMGREY}
          borderRadius={8}
          highlightColor={TICKETSMS_COLORS_LIGHTGREY}
        />
      </div>
    </div>
  )
}

export default GSTicketSkeleton
